import { render, staticRenderFns } from "./test3.vue?vue&type=template&id=9abeac3e&scoped=true"
import script from "./test3.vue?vue&type=script&lang=js"
export * from "./test3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9abeac3e",
  null
  
)

export default component.exports